var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12px","height":"12px","viewBox":"0 0 12 12","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"6","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }